// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".parts-order-grid[data-v-53de314b] {\n  display: grid;\n  grid-template-columns: 3% 5% 30% 10% 10% 3% 3% 3% 3% 10% 10% 10%;\n}", ""]);
// Exports
module.exports = exports;
